import { createFileRoute } from "@tanstack/react-router";

import SignUpConfirm from "@/features/auth/SignupConfirm";
import BasicLayout from "@/layouts/Basic";

export const Route = createFileRoute("/confirm")({
  component: () => (
    <BasicLayout>
      <SignUpConfirm />
    </BasicLayout>
  ),
});
